import { render } from "./App.vue?vue&type=template&id=be24742c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=be24742c&lang=css"

import exportComponent from "I:\\JavaWork\\Recruit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__